module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"description_with_reward":"次のキーワードについて書くと、AI分析後にポイントを追加付与","description_wihout_reward":"次のキーワードについて書いてみてください。"}}')
  delete Component.options._Ctor
}
